import React, { Component } from "react"
import NoBooking from "../table-scaffolding/no-booking"
import NoBookingResults from "../table-scaffolding/no-booking-results"
import Loading from "../table-scaffolding/loading"
import Booking from "../table-scaffolding/booking"
import BookingTableHeader from "../table-scaffolding/Booking-Table-Header"
import DatePickerForm from "../table-scaffolding/DatePickerForm"
import Svg from "../../../../_svgs/svg"
import * as dateHelper from "../../../../../booking/helpers/date"
import moment from "moment"
// import * as lodash from 'lodash';

class BookingTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      bookings: props.bookings,
      fromDate: undefined,
      toDate: undefined,
      showAccordion: props.showAccordion,
      accordionOpen: false,
      showSearchResultBookings: false,
    }
  }

  componentDidUpdate(prevState, prevProps) {
    if (this.props.bookings !== prevProps.bookings) {
      this.setState({
        bookings: this.props.bookings,
      })
    }

    const target = document.querySelector(`.${this.props.sourceTable}-table-accordion`)
    if (target && target.classList.contains("is-open")) {
      let bookingTable = target.querySelector(".stylish-table")
      target.style.height = bookingTable.offsetHeight + "px"
    }
  }

  changeDateState = (fromDate, toDate) => {
    this.setState({
      fromDate: fromDate,
      toDate: toDate,
    })
    if (fromDate || toDate) {
      this.setState({
        showSearchResultBookings: true,
        showAccordion: false,
      })
    }
  }

  renderBookings(bookings) {
    return bookings.map((booking) => (
      <Booking
        sourceTable={this.props.sourceTable}
        key={booking.bookingId}
        bookingDate={booking.bookingDateTime}
        status={this.props.getStatus(booking)}
        price={booking.price}
        arrivalTime={booking.arrivalDateTime}
        departureTime={booking.departureDateTime}
        licenceplate={booking.vehicleRegistrationNumber}
        carpark={booking.carParkName}
        bookingNo={booking.bookingReference}
        convertBookingTime={this.props.convertBookingTime}
        customerEmail={booking.customerEmail}
        lang={this.props.lang}
      />
    ))
  }

  filterBookingsByDate() {
    const inputFromDate = moment(dateHelper.getLocaleDateFromFormat(this.state.fromDate, "DD / MM / YYYY", this.props.lang))
    const inputToDate = moment(dateHelper.getLocaleDateFromFormat(this.state.toDate, "DD / MM / YYYY", this.props.lang))

    return this.state.bookings.filter((b) => {
      const bookingFromDate = dateHelper.GetMomentDate(b.arrivalDateTime)
      const bookingToDate = dateHelper.GetMomentDate(b.departureDateTime)

      if (moment(bookingFromDate).isBetween(inputFromDate, inputToDate) || moment(bookingToDate).isBetween(inputFromDate, inputToDate)) {
        return true
      }
      return false
      //b.arrivalTime >= inputFromDate && b.departureTime <= inputToDate
    })
  }

  showHideContent(event, classname) {
    event.preventDefault()
    let elem = event.currentTarget
    elem.__toggle = !elem.__toggle
    let target = document.querySelector(classname)
    let bookingsTable = target.querySelector(".stylish-table")
    if (elem.__toggle) {
      target.style.height = bookingsTable.style.scrollHeight + "px"
      elem.classList.add("is-active")
      elem.classList.add("hidden-header")
    } else {
      target.style.height = 0 + "px"
      elem.classList.remove("is-active")
      elem.classList.remove("hidden-header")
    }

    this.setState({
      accordionOpen: !this.state.accordionOpen,
    })
  }

  render() {
    let bookings = this.state.bookings ? [...this.state.bookings] : []
    let preAccordionBookings = []
    let accordionBookings = []
    if (this.state.fromDate && this.state.toDate) {
      bookings = this.filterBookingsByDate()
    }

    if (bookings.length > 0) {
      preAccordionBookings = bookings.slice(0, 6)
      accordionBookings = bookings.slice(6, bookings.length)
    }

    return (
      <section className="deck deck--padding-top deck--margin-bottom">
        {this.props.pageHeader ? (
          <header className="category-header ">
            <div className="category-header__inner">
              <h1 className="headline-md">{this.props.pageHeader || "Ordre Historik"}</h1>
            </div>
          </header>
        ) : null}
        <div className="order-history-table">
          <header className="order-history-table__header">
            <h4>{this.props.header}</h4>
            {this.props.showDatePicker ? (
              <DatePickerForm
                sourceTable={this.props.sourceTable}
                minDateToday={this.props.minDateToday}
                changeDateState={this.changeDateState}
                bookingDatePickerFrom={this.props.bookingDatePickerFrom}
                bookingDatePickerTo={this.props.bookingDatePickerTo}
                datepickerButtonText={this.props.datepickerButtonText}
              />
            ) : (
              ""
            )}
          </header>

          <div className={`stylish-table ${this.props.sourceTable + "-table"}`}>
            <BookingTableHeader
              sourceTable={this.props.sourceTable}
              bookingStatus={this.props.bookingStatus}
              bookingDate={this.props.bookingDate}
              bookingReservationNumber={this.props.bookingReservationNumber}
              bookingArrivalDate={this.props.bookingArrivalDate}
              bookingDepartureDate={this.props.bookingDepartureDate}
              bookingCarpark={this.props.bookingCarpark}
              bookingPrice={this.props.bookingPrice}
              bookingLicenceplate={this.props.bookingLicenceplate}
              hideHeader={false}
            />

            {this.props.loadStatus ? (
              <Loading bookingLoadingText={this.props.bookingLoadingText} />
            ) : this.state.showSearchResultBookings ? (
              this.renderBookings(bookings)
            ) : (
              this.renderBookings(preAccordionBookings)
            )}
            {preAccordionBookings.length === 0 && this.props.loadStatus === false && !this.state.showSearchResultBookings ? (
              <NoBooking bookingNoBookingsText={this.props.bookingNoBookingsText} />
            ) : (
              ""
            )}
            {preAccordionBookings.length === 0 && this.props.loadStatus === false && this.state.showSearchResultBookings ? (
              <NoBookingResults bookingNoSearchResultsText={this.props.bookingNoSearchResultsText} />
            ) : (
              ""
            )}
          </div>

          <div
            className={`${this.props.sourceTable + "-table-accordion"} ${this.state.accordionOpen ? "is-open" : ""}`}
            style={{ height: 0, overflow: "hidden", transition: "height 0.4s ease" }}
          >
            <div className={`stylish-table`}>
              <BookingTableHeader
                sourceTable={this.props.sourceTable}
                bookingStatus={this.props.bookingStatus}
                bookingDate={this.props.bookingDate}
                bookingReservationNumber={this.props.bookingReservationNumber}
                bookingArrivalDate={this.props.bookingArrivalDate}
                bookingDepartureDate={this.props.bookingDepartureDate}
                bookingCarpark={this.props.bookingCarpark}
                bookingPrice={this.props.bookingPrice}
                bookingLicenceplate={this.props.bookingLicenceplate}
                hideHeader={true}
              />
              {accordionBookings.length > 0 ? this.renderBookings(accordionBookings) : ""}
            </div>
          </div>
          {this.props.loadStatus ? (
            ""
          ) : accordionBookings.length > 0 && this.state.showAccordion ? (
            <a
              className="button button--expander js--accordion-trigger"
              onClick={(e) => this.showHideContent(e, `.${this.props.sourceTable}-table-accordion`)}
            >
              <span className="text">{this.props.showMore || "Vis flere"}</span>
              <span className="text2">{this.props.showLess || "Skjul"}</span>
              <span className="icon">
                <Svg iconName={"arrowdownangle"} />
              </span>
            </a>
          ) : (
            ""
          )}
        </div>
      </section>
    )
  }
}
export default BookingTable
